import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import ReferencialAction from 'referencial/action/ReferencialAction'
import i18n from 'simple-react-i18n'
import {
    H_CAMPAIGN_QUALITO_DASHBOARD,
    H_CAMPAIGN_QUALITO_TRACKING,
} from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CityAction from '../../../referencial/components/city/actions/CityAction'
import ContributorAction from '../../../referencial/components/contributor/actions/ContributorAction'
import ParameterAction from '../../../referencial/components/parameter/actions/ParameterAction'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import QualityAction from '../../actions/QualityAction'
import UnitAction from 'referencial/components/unit/actions/UnitAction'
import SupportAction from 'referencial/components/support/actions/SupportAction'
import FractionAction from 'referencial/components/fraction/actions/FractionAction'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ProgressBar from 'components/progress/ProgressBar'
import { Card, CardContent, Stack } from '@mui/material'

const QualityCampaignApp = () => {
    const dispatch = useDispatch()
    const { id } = useParams()

    const {
        campaign,
        campaignStations,
        campaignParameters,
        campaignPlannings,
        campaignPlanningsExceptions,
        campaignProgress,
        edilaboFiles,
    } = useSelector(store => ({
        campaign: store.CampaignReducer.campaign,
        campaignStations: store.CampaignReducer.campaignStations,
        campaignParameters: store.CampaignReducer.campaignParameters,
        campaignPlannings: store.CampaignReducer.campaignPlannings,
        campaignPlanningsExceptions: store.CampaignReducer.campaignPlanningsExceptions,
        campaignProgress: store.CampaignReducer.campaignProgress,
        edilaboFiles: store.CampaignReducer.edilaboFiles,
    }), shallowEqual)

    useEffect(() => {
        return () => {
            dispatch(CampaignAction.resetCampaign())
        }
    }, [])

    const { progress, isLoaded } = useProgressDispatch(() => {
        const campaignsFetch = id !== 'new' ?
            [
                dispatch(CampaignAction.fetchCampaign('quality', id)),
                dispatch(CampaignAction.fetchCampaignStation('quality', id)),
                dispatch(CampaignAction.fetchCampaignParameters(id)),
                dispatch(CampaignAction.fetchCampaignPlannings(id)),
                dispatch(CampaignAction.fetchCampaignProgress('quality', id)),
                dispatch(CampaignAction.fetchEDILABOFile(id)),
            ]
            :
            []
        return [
            dispatch(QualityAction.fetchQualitometersLight()),
            dispatch(ContributorAction.fetchContributors()),
            dispatch(CityAction.fetchCities()),
            dispatch(ParameterAction.fetchSelectionsWithParam()),
            dispatch(ReferencialAction.fetchSandreCodes()),
            dispatch(ParameterAction.fetchParameters()),
            dispatch(UnitAction.fetchUnits()),
            dispatch(SupportAction.fetchSupports()),
            dispatch(FractionAction.fetchFractions()),
            dispatch(QualityAction.fetchAllPoints()),
            ...campaignsFetch,
        ]
    }, [id])

    const navLinks = useMemo(() => {
        return [
            {
                href: `/quality/campaign/${id}/dashboard`,
                icons: 'dashboard',
                name: i18n.dashboard,
                habilitation: H_CAMPAIGN_QUALITO_DASHBOARD,
            },
            {
                href: `/quality/campaign/${id}/tracking`,
                icons: 'date_range',
                name: i18n.tracking,
                habilitation: H_CAMPAIGN_QUALITO_TRACKING,
            },
            {
                href: `/quality/campaign/${id}/file`,
                icons: 'description',
                name: i18n.files,
                habilitation: H_CAMPAIGN_QUALITO_TRACKING,
            },
        ].filter(l => componentHasHabilitations(l.habilitation))
    }, [id])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks} />
            <main>
                <div className='row no-margin'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            {isLoaded ?
                                <Outlet
                                    context={{
                                        campaign,
                                        campaignStations,
                                        campaignParameters,
                                        campaignPlannings,
                                        campaignPlanningsExceptions,
                                        campaignProgress,
                                        edilaboFiles,
                                    }}
                                />
                                :
                                <Stack padding={1}>
                                    <Card>
                                        <CardContent>
                                            <ProgressBar progress={progress} withMessage />
                                        </CardContent>
                                    </Card>
                                </Stack>
                            }
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default QualityCampaignApp
